import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React, { useState } from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import usePopOver from "@/hooks/use-popover";
import { IServiceInterface } from "@/interfaces/service-interface.interface";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { ServiceInterfaceTableRow } from "./row";
import { SERVICE_INTERFACE_TABLE_COLUMNS } from "../../constants";
import { ServiceInterfacePopover } from "../Popover";
import { SettingsModal } from "../SettingsModal";

type Props = {
  data: PaginatedResponse<IServiceInterface>;
  pagination: Pagination;
  messages: ServiceInterfaceMessages;
};

export function ServiceInterfaceTable({ data, pagination, messages }: Props) {
  const { pageNumber, pageSize, changePage, extend } = pagination;
  const { openPopover, anchorEl, closePopover, isOpen, selected } =
    usePopOver<IServiceInterface>();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsServiceInterfaceId, setSettingsServiceInterfaceId] = useState<number | null>(null);

  const handleOpenSettings = (item: IServiceInterface) => {
    setSettingsServiceInterfaceId(item.id);
    setSettingsOpen(true);
    closePopover();
  };

  const columns = SERVICE_INTERFACE_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="integrations-table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell key={`${index}-${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items.map((item, index) => (
              <ServiceInterfaceTableRow
                key={item.id}
                item={item}
                index={index}
                messages={messages}
                onOpenPopover={openPopover}
              />
            ))}
          </TableBody>
        </Table>
        {selected && (
          <ServiceInterfacePopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
            onOpenSettings={handleOpenSettings}
          />
        )}
      </TableContainer>
      <SettingsModal
        isOpen={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        serviceInterfaceId={settingsServiceInterfaceId}
        messages={messages}
      />
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, page) => changePage(page)}
      />
    </>
  );
}
